import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { TransactionReceiptResponseDto } from '../dtos';

export class TransactionReceiptState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public transactionReceipt: Array<TransactionReceiptResponseDto>;

  constructor() {
    this.transactionReceipt = null;
    this.isLoading = false;
    this.failures = null;
  }
}
